import React from 'react';

export default function CashIn() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Cash In</h1>
      <p className="text-gray-500">Halaman Cash In</p>
    </div>
  );
}
